<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="项目角色" prop="projectRole">
        <dict-select
          size="mini"
          v-model="formData.projectRole"
          url="/digitalCenter/common/dict/system"
          :body="{dictType:'projectRole'}"
          placeholder="请选择项目角色"
          clearable
          filterable
          :disabled="disabled"
        ></dict-select>
      </el-form-item>
      <el-form-item label="参与人姓名" prop="personName">
        <el-input v-model="formData.personName" :disabled="disabled" clearable size="mini"></el-input>
      </el-form-item>
      <el-form-item label="参与人手机" prop="personMobile">
        <el-input v-model="formData.personMobile" :disabled="disabled" clearable size="mini"></el-input>
      </el-form-item>
      <el-form-item label="固定电话" prop="personPhone">
        <el-input v-model="formData.personPhone" :disabled="disabled" clearable size="mini"></el-input>
      </el-form-item>
      <el-form-item label="参与人Email" prop="personEmail">
        <el-input v-model="formData.personEmail" :disabled="disabled" clearable size="mini"></el-input>
      </el-form-item>
      <el-form-item label="参与人职务" prop="personJob">
        <el-input v-model="formData.personJob" disabled clearable size="mini"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import { saveApi } from '@api/projectManager/infoParticipant'

export default {
  data () {
    return {
      disabled: false,
      formData: {
        participantCode: '',
        prjCode: '',
        seqno: '',
        projectRole: '',
        personUserCode: '',
        personName: '',
        personMobile: '',
        personPhone: '',
        personEmail: '',
        personJob: ''
      },
      rules: {
        // prjTagType: [
        //   { required: true, message: '请选择标签类型', trigger: 'blur' }
        // ],
        // prjTagName: [
        //   { required: true, message: '请输入标签名称', trigger: 'blur' },
        //   { max: 50, message: '长度在50个字符以内', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad (options) {
      this.disabled = options.disabled
      this.formData = options.data
    },
    // 保存数据
    save () {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.infoParticipantSaveApi(this.formData)
            .then(res => {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success'
              })
              // 通知父组件保存成功
              this.$emit('success')
            })
        } else {
          return false
        }
      })
    },
    // 初始化表单数据
    init () {
      this.disabled = false
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>
